import React, { Component } from "react";
import CryptoJS from "crypto-js";
import ReactDom from "react-dom";
//import "assets/css/safexpay-web.css"
import { base_url } from "assets/utils/const";
import Spinner from "reactstrap/lib/Spinner";
import "./ContactUs.css";
import Backdrop from "../Backdrop/Backdrop";
import axios from "axios";

class StatusTrackForm extends Component {
  state = {
    transaction: "",
    order: "",
    bankRef: "",
    secretKey: "",
    trackStatus: "",
    description: "",
    orderError: false,
    isLoaded: false,
    blankFieldError: false,
  };

  flag = 0;
  checkflag = false;
  datasend = false;

  componentDidMount() {
    //   if (this.props.open) {
    //     this.setState({
    //       transaction: "",
    //       order: "",
    //       bankRef: "",
    //       trackStatus: "",
    //       description: "",
    //       orderError: false,
    //       blankFieldError: false
    //     });
    //   }
    fetch(`${base_url}api/getMasterKey`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((result) => {
        this.setState({ secretKey: result.data });
      });
  }
  postdatahandler = (e) => {
    const { transaction, order, bankRef, secretKey } = this.state;

    this.setState({
      description: "",
      trackStatus: "",
      orderError: false,
      isLoaded: true,
      blankFieldError: false,
    });

    if (!transaction && !order && !bankRef) {
      this.setState({ blankFieldError: true, isLoaded: false });
      return false;
    }

    if (order) {
      if (!transaction && !bankRef) {
        this.setState({ orderError: true, isLoaded: false });
        return false;
      }
    }
    const data = {
      ag_ref: transaction,
      order_no: order,
      pg_ref: bankRef,
    };

    var base64IV = "0123456789abcdef";

    var parsedBase64Key = CryptoJS.enc.Base64.parse(secretKey);
    var IV = CryptoJS.enc.Utf8.parse(base64IV);
    // Encryption process
    // if (typeof JSON.stringify(data) !== "string") {
    //   upass = upass.toString();
    // }

    // this is Base64-encoded encrypted data
    var encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      parsedBase64Key,
      {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: IV,
      }
    );
    const encryptedCipherText = encryptedData.toString();

    fetch(`${base_url}api/getTransactionStatus`, {
      method: "POST",
      body: JSON.stringify({
        transactionStatusRequest: encryptedCipherText,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        var decryptedData = CryptoJS.AES.decrypt(
          result.payLoad,
          parsedBase64Key,
          {
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            iv: IV,
          }
        );
        // this is the decrypted data as a string
        var decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
        console.log("DecryptedText = " + decryptedText);
        let status = JSON.parse(decryptedText).transaction_status;
        if (status) {
          this.setState({ trackStatus: status, isLoaded: false });
        }
        let description = JSON.parse(decryptedText).description;
        if (description) {
          this.setState({ description, isLoaded: false });
        }
        // this.setState({
        //   transaction: "",
        //   order: "",
        //   bankRef: "",
        // });
      });
  };

  resetState = () => {
    this.setState({
      transaction: "",
      order: "",
      bankRef: "",
      trackStatus: "",
      description: "",
      orderError: false,
      blankFieldError: false,
    });
    this.props.click();
  };
  render() {
    if (!this.props.open) return null;
    var attchedClasses = ["dv-Registration-content", "Open1"];
    var backdropcl1 = ["Backdrop3"];
    // if (this.props.open) {
    //   attchedClasses = ["dv-Registration-content", "Open1"];
    //   backdropcl1 = ["Backdrop3"];
    // }
    return ReactDom.createPortal(
      <>
        {/* <div
          className={backdropcl1.join(" ")}
          id="backdrop11"
          onClick={this.props.click}
          data-backdrop="static"
          data-keyboard="false"
        ></div> */}

        <section className={attchedClasses.join(" ")}>
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
          ></link>

          <div className="dv-registration-form dv-form pt-5" id="fullform10">
            <button className="close" onClick={this.resetState}>
              <span aria-hidden={true}>×</span>
            </button>
            <div className="form-group">
              <div className="contus track" style={{ marginBottom: "0.1rem" }}>
                <h5
                  className="section-heading border-heading"
                  style={{ fontSize: "1.5rem", letterSpacing: "0" }}
                >
                  Track Transaction Status
                </h5>
                <p style={{ marginBottom: "2rem", textAlign: "center" }}>
                  Enter the below details to track your transaction status.
                </p>
              </div>

              <label htmlFor="txtFirstName">Transaction Reference Number</label>
              <input
                type="number"
                className="form-control form-option"
                id="txtFirstName1"
                placeholder="Enter number"
                value={this.state.transaction}
                onChange={(event) =>
                  this.setState({ transaction: event.target.value })
                }
                disabled={this.state.bankRef}
              />
            </div>
            <div className="form-group">
              <label htmlFor="txtEmail">Order Number</label>
              <input
                type="text"
                required
                className="form-control form-option"
                id="txtEmail11"
                placeholder="Enter number"
                value={this.state.order}
                onChange={(event) =>
                  this.setState({ order: event.target.value })
                }
                disabled={this.state.transaction || this.state.bankRef}
              />
            </div>
            <div className="form-group">
              <label htmlFor="txtMobile">Bank Reference Number</label>
              <input
                type="text"
                className="form-control form-option"
                id="txtMobile11"
                placeholder="Enter Number"
                value={this.state.bankRef}
                onChange={(event) =>
                  this.setState({ bankRef: event.target.value })
                }
                disabled={this.state.transaction}
              />
            </div>
            <div>
              {this.state.trackStatus && (
                <span>
                  Status:{" "}
                  <small className="track_status">
                    {this.state.trackStatus}
                  </small>
                  {/* {(this.state.trackStatus === "Successful" ||
                      this.state.trackStatus === "Refund") && (
                      <small className="track_status track_success">
                        {this.state.trackStatus}
                      </small>
                    )}
                    {(this.state.trackStatus === "Pending" ||
                      this.state.trackStatus === "Chargeback") && (
                      <small className="track_status track_pending">
                        {this.state.trackStatus}
                      </small>
                    )}
                    {(this.state.trackStatus === "Failed" ||
                      this.state.trackStatus === "Expired" ||
                      this.state.trackStatus === "Aborted") && (
                      <small className="track_status track_failed">
                        {this.state.trackStatus}
                      </small>
                    )} */}
                </span>
              )}
              {this.state.description !== "No Data Found" && (
                <small className="err"> {this.state.description}</small>
              )}
              {this.state.description === "No Data Found" && (
                <small className="err">
                  {" "}
                  No record found, please check your details.{" "}
                </small>
              )}
              {this.state.blankFieldError && (
                <small className="err">Please fill all required fields.</small>
              )}
              {this.state.orderError && (
                <small className="err">
                  Please provide the either valid Transaction reference Number
                  or valid Bank reference number along with Order number.
                </small>
              )}
            </div>
            <div
              className="text-center btn-center"
              style={{ marginTop: "1rem" }}
            >
              <button
                className="submitbtn01 btn-center"
                id="submitbtn1"
                type="submit"
                onClick={(e) => this.postdatahandler(e)}
                disabled={this.state.isLoaded}
              >
                Submit
                {this.state.isLoaded ? (
                  <Spinner
                    size="sm"
                    color="light"
                    className="btn-loader mar-left"
                  />
                ) : null}
              </button>
            </div>
            <div className="text-center myspin" id="spinner">
              <button className="submitbtn01">
                Loading <span className="fa fa-refresh fa-spin"></span>
              </button>
            </div>
            <div className="dv-bottom-bg">
              <div className="first-bottom-bg"></div>
              <div className="second-bottom-bg"></div>
            </div>
          </div>
        </section>
      </>,
      document.getElementById("portal")
    );
  }
}

export default StatusTrackForm;
